import { useEffect, useState } from 'react';
import * as LicenseAPI from '../api/Licenses';
import { useAuthenticatedUser } from './user';

/**
 * Hook to check if the current user has an active license.
 * Returns loading state and license status.
 *
 * For teachers, this fetches license status from the API.
 * For non-teachers, it always returns true (no license needed).
 */
export function useLicenseCheck() {
  const user = useAuthenticatedUser();
  const [hasActiveLicense, setHasActiveLicense] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Only check license for teachers
    if (!user) {
      setIsLoading(true);
      return;
    }

    if (user.role !== 'teacher') {
      setHasActiveLicense(true); // Non-teachers don't need licenses
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    LicenseAPI.getLicenseStatus()
      .then((response) => {
        setHasActiveLicense(response.data.data.has_active_license);
      })
      .catch(() => {
        setHasActiveLicense(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [user]);

  return { hasActiveLicense, isLoading };
}

